import { render, staticRenderFns } from "./advert.vue?vue&type=template&id=ca3ab72e&scoped=true"
import script from "./advert.vue?vue&type=script&lang=js"
export * from "./advert.vue?vue&type=script&lang=js"
import style0 from "./advert.vue?vue&type=style&index=0&id=ca3ab72e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca3ab72e",
  null
  
)

export default component.exports